import { PartyType } from '../../party/party-type.enum';

export type CommercialPartySource = 'CRM' | 'PARTY' | 'LEGACY';

/**
 * Stable party reference shared by operational and commercial documents.
 * CRM identifiers take precedence whenever crmClientId is present.
 */
export interface CommercialPartyReference {
    source: CommercialPartySource;
    crmClientId?: number | null;
    crmAccountId?: number | null;
    crmContactId?: number | null;
    partyEntityId?: number | null;
    partyEntityType?: PartyType | null;
    partyContactEntityId?: number | null;
    partyContactEntityType?: PartyType | null;
    legacyCompanyId?: number | null;
    legacyCustomerId?: number | null;
}

export function normalizeCommercialPartyReference(
    value?: Partial<CommercialPartyReference> | null
): CommercialPartyReference {
    if (value?.crmClientId) {
        return {
            source: 'CRM',
            crmClientId: value.crmClientId,
            crmAccountId: value.crmAccountId ?? null,
            crmContactId: value.crmContactId ?? null,
            partyEntityId: null,
            partyEntityType: null,
            partyContactEntityId: null,
            partyContactEntityType: null,
            legacyCompanyId: null,
            legacyCustomerId: null
        };
    }
    if (value?.source === 'PARTY' || (value?.partyEntityId && value?.partyEntityType)) {
        return {
            source: 'PARTY',
            crmClientId: null,
            crmAccountId: null,
            crmContactId: null,
            partyEntityId: value.partyEntityId ?? null,
            partyEntityType: value.partyEntityType ?? null,
            partyContactEntityId: value.partyContactEntityId ?? null,
            partyContactEntityType: value.partyContactEntityType ?? null,
            legacyCompanyId: null,
            legacyCustomerId: null
        };
    }
    return {
        source: value?.source === 'LEGACY' ? 'LEGACY' : 'CRM',
        crmClientId: null,
        crmAccountId: null,
        crmContactId: null,
        partyEntityId: null,
        partyEntityType: null,
        partyContactEntityId: null,
        partyContactEntityType: null,
        legacyCompanyId: value?.legacyCompanyId ?? null,
        legacyCustomerId: value?.legacyCustomerId ?? null
    };
}
